import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import { Edit, Delete, PauseCircleFilledOutlined, PauseCircleOutlineOutlined, Crib } from "@mui/icons-material";
import React from "react";
import { Network } from "../../../fstn/network";
import { connect } from "react-redux";
import {UpdateFocus, updateFocus, UpdateModeData, updateModeData} from "../../../redux/slices/editor";
import AddRemoveNodeTagMenuItem from "../../tags/AddRemoveNodeTagMenuItem";

interface IProps
{
    anchorEl: HTMLElement | null,
    deleteEnabled: boolean
    debugEnabled: boolean
    handleEditClick: (event: React.MouseEvent<HTMLElement>) => void
    handleDeleteClick: (event: React.MouseEvent<HTMLElement>) => void
    handlePauseClick: (event: React.MouseEvent<HTMLElement>) => void
    setAddTagType: (type: string) => void
    id: string
    network: Network
    onClose: () => void
    pauseState?: boolean
    selection: string[]
    project: string
    updateFocus: UpdateFocus
    updateModeData: UpdateModeData
}

function ContextMenu({id, anchorEl, pauseState, handleEditClick, deleteEnabled, handleDeleteClick, debugEnabled,
                         handlePauseClick, network, onClose, setAddTagType, selection, updateFocus, updateModeData}: IProps)
{
    const open = Boolean(anchorEl);
    const handleContextMenu = (event: React.MouseEvent<HTMLElement>) =>
    {
        event.preventDefault();
        onClose();
    }
    const child = Array.from(network.states.keys()).find(state => network.states.get(state)!.parent === id);
    const handleSelectChild = () =>
    {
        updateModeData({root: id});
        child && updateFocus(child);
        onClose();
    };

    return (
        <Menu id={`${id}_menu`} anchorEl={anchorEl} open={open} onClose={onClose} onContextMenu={handleContextMenu}>
            <AddRemoveNodeTagMenuItem onClose={onClose} setAddTagType={setAddTagType} selection={selection} parentOpen={open} />
            <Divider />
            <MenuItem onClick={handleEditClick} style={{ minWidth: "180px" }}>
                <ListItemIcon>
                    <Edit fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleDeleteClick} disabled={!deleteEnabled}>
                <ListItemIcon>
                    <Delete fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
            </MenuItem>
            {child &&
                <MenuItem onClick={handleSelectChild}>
                    <ListItemIcon>
                        <Crib fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Goto child</ListItemText>
                </MenuItem>
            }
            <Divider />
            <MenuItem onClick={handlePauseClick} disabled={!debugEnabled}>
                <ListItemIcon>
                    {pauseState ? <PauseCircleFilledOutlined /> : <PauseCircleOutlineOutlined />}
                </ListItemIcon>
                <ListItemText>Pause</ListItemText>
            </MenuItem>
        </Menu >
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
    updateFocus,
    updateModeData
})(ContextMenu);
